import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Modal,
  Text
} from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import ReviewerSummary from "./ReviewerSummary";
import { PlanSubmission } from "@/Utils/Plan/PlanSubmisionsTypes";

type PlanApprovalStatusModalProps = {
  show: boolean;
  onClose: () => void;
  submissionData: PlanSubmission;
};

const PlanApprovalStatusModal = ({
  show,
  onClose,
  submissionData
}: PlanApprovalStatusModalProps) => {
  return (
    <Modal id="approval-status-modal" show={show} onClose={onClose}>
      <DialogTitle divider={true} onClose={onClose}>
        {appstr("Approval Status")}
      </DialogTitle>
      <DialogContent>
        <Flex margin={"16px 0 0 0"} direction="column" gap="12px">
          <Text size="small">
            {appstr("This plan has the following approver(s) and their approval status:")}
          </Text>
          <Flex direction="column" gap="8px">
            {submissionData.reviewers.map(reviewer => (
              <ReviewerSummary key={reviewer.username} reviewer={reviewer} />
            ))}
          </Flex>
        </Flex>
      </DialogContent>
      <DialogActions>
        <DialogActions.Primary
          dataTestId="planning-toolbar-plan-approval-status-close-btn"
          onClick={onClose}
        >
          {appstr("Close")}
        </DialogActions.Primary>
      </DialogActions>
    </Modal>
  );
};

export default PlanApprovalStatusModal;
